import classNames from "classnames"
import { TWENTY_MB } from "common/utils/constants"
import { ProgressSpinner } from "primereact/progressspinner"
import { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import { useTranslation } from "react-i18next"
import DropzoneLite from "./DropzoneLite"
import DropzoneRegular from "./DropzoneRegular"

import "./dropzone.scss"

const Dropzone = ({
  onDrop,
  onDropAccepted,
  onDropRejected,
  loading,
  accept,
  maxFiles,
  maxSize = TWENTY_MB,
  style,
  butonLabel,
  hideAcceptedFilesMsg = false,
  lite = false,
  multiple = true,
  children,
  acceptLabel,
  fluid = false,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropAccepted,
    onDropRejected,
    accept,
    maxFiles,
    maxSize,
    multiple,
  })

  const RenderDropzone = useCallback(() => {
    if (loading) {
      return (
        <ProgressSpinner
          className='spinner'
          style={{ width: "50px", height: "50px" }}
          strokeWidth='8'
          fill='#EEEEEE'
          animationDuration='.5s'
        />
      )
    }

    if (children) {
      return (
        <>
          {children}

          <input {...getInputProps()} />
        </>
      )
    }

    if (lite) {
      return <DropzoneLite getInputProps={getInputProps} />
    }

    return (
      <DropzoneRegular
        acceptLabel={acceptLabel}
        butonLabel={butonLabel || `${t("importar.dropDown.uploadDocButton")}`}
        hideAcceptedFilesMsg={hideAcceptedFilesMsg}
        getInputProps={getInputProps}
      />
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    acceptLabel,
    butonLabel,
    children,
    getInputProps,
    hideAcceptedFilesMsg,
    lite,
    loading,
  ])

  return (
    <>
      <div
        className={`p-0 m-0 ${!fluid && "container"}`}
        style={style}
      >
        <div
          {...getRootProps()}
          className={classNames([
            "d-flex justify-content-center align-items-center flex-column",
            {
              "dropzone-container-lite": lite,
              "dropzone-container": !lite && !children,
              "dropzone-ondrag": isDragActive,
            },
          ])}
        >
          <RenderDropzone />
        </div>
      </div>
    </>
  )
}

export default Dropzone
